import Main from './components/list/Main.vue'
import Import from './components/import/Main.vue'

import UploadFile from './components/import/UploadFile.vue'
import CrossData from './components/import/CrossData.vue'

export default [
    {
        name: 'incoming.index',
        path: '/incoming',
        component: Main,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: 'incoming.import',
        path: '/incoming/import',
        components: { modal: Import },
        redirect: '/incoming/import/upload-file',
        meta: {
            requiresAuth: true
        },
        children: [
            {
                name: 'incoming.import.upload-file',
                path: '/incoming/import/upload-file',
                component: UploadFile,
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'incoming.import.cross-data',
                path: '/incoming/import/cross-data',
                component: CrossData,
                meta: {
                    requiresAuth: true
                }
            }
        ]
    }
]



// WEBPACK FOOTER //
// ./src/modules/incoming/routes.js